import { render } from "./NewEvent.vue?vue&type=template&id=b2ee3348&scoped=true"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"

import "./NewEvent.vue?vue&type=style&index=0&id=b2ee3348&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b2ee3348"

export default script